<template>
  <Poptip v-model="showPop" placement="bottom" transfer @on-popper-hide="handleHide">
    <Icon :class="checkedItem[0] ? 'filter-checked' : ''"
          style=" cursor: pointer"
          custom="i-custom icon-filter"/>
    <div slot="content">
      <CheckboxGroup v-model="checkedItem" style="overflow: auto;max-height: 200px">
        <Checkbox v-for="item in filterList"
                  :label="item.value"
                  :key="item._uid"
                  style="display: block">
          {{item.label}}
        </Checkbox>
      </CheckboxGroup>
      <div class="filter-footer">
        <Button type="text" size="small" @click="handleCancel">重置</Button>
        <Button type="primary" size="small" @click="handleSave">确定</Button>
      </div>
    </div>
  </Poptip>
</template>

<script>
  export default {
    name: "table-filter",
    props: {
      filterList: Array
    },
    data() {
      return {
        showPop: false,
        checkedItem: [],
        savedItem: []
      }
    },
    methods: {
      // 确定
      handleSave() {
        this.savedItem = this.checkedItem
        this.showPop = false
        this.$emit('on-ok', this.checkedItem)
      },
      // 重置
      handleCancel() {
        this.checkedItem = []
        this.savedItem = []
        this.showPop = false
        this.$emit('on-reset')
      },
      // 提示框消失
      handleHide() {
        this.checkedItem = this.savedItem
      }
    },
  }
</script>

<style scoped>
  .filter-checked {
    color: #5cadff;
  }

  .filter-footer {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid #ddd;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/views/my-components/table-filter/table-filter.vue